export type User = {
    id: string,
    companyName: string,
    companyBook: string,
    strategy: string,
    futuresPNL: string,
    futuresDailyChange: string,
    swapsPNL: string,
    swapsDailyChange: string,
    totalPNL: string,
    totalDailyChange: string
};

export const fakeData: User[] = [
    {
        id: '1',
        companyName: 'Cara Commodities',
        companyBook: 'CCBGM',
        strategy: '1000',
        futuresPNL: '-8,120,393.77',
        futuresDailyChange: '-33,272.50',
        swapsPNL: '15,060,043.50',
        swapsDailyChange: '57,646.07',
        totalPNL: '6,939,649.73',
        totalDailyChange: '24,373.57'
    },
    {
        id: '2',
        companyName: 'Vitol Trading',
        companyBook: 'CCBGM',
        strategy: '1001',
        futuresPNL: '-26,420.50',
        futuresDailyChange: '6,922.50',
        swapsPNL: '4,905.00',
        swapsDailyChange: '5,048.93',
        totalPNL: '-21,515.50',
        totalDailyChange: '11,971.43'
    },
    {
        id: '3',
        companyName: 'Trafigura Group',
        companyBook: 'CCCr',
        strategy: '21000',
        futuresPNL: '0.00',
        futuresDailyChange: '0.00',
        swapsPNL: '-16,100.00',
        swapsDailyChange: '0.00',
        totalPNL: '-16,100.00',
        totalDailyChange: '0.00'
    },
    {
        id: '4',
        companyName: 'Glencore International',
        companyBook: 'CCCr',
        strategy: '21003',
        futuresPNL: '31,873,410.00',
        futuresDailyChange: '-9,060.00',
        swapsPNL: '-20,046,903.00',
        swapsDailyChange: '-45,314.00',
        totalPNL: '-18,173,493.00',
        totalDailyChange: '-54,374.00'
    },
    {
        id: '5',
        companyName: 'Mercuria Energy Group',
        companyBook: 'CCCr',
        strategy: '31000',
        futuresPNL: '-89,649,945.00',
        futuresDailyChange: '0.00',
        swapsPNL: '73,793,295.73',
        swapsDailyChange: '0.00',
        totalPNL: '-15,856,649.27',
        totalDailyChange: '0.00'
    }
    // I've included the first 5 rows to keep the example concise
    // The full dataset would continue with similar company names
];

//50 us states array
export const usStates = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
    'Puerto Rico',
];
export const citiesList = [
    'San Francisco',
    'Richmond',
    'Riverside',
    'Los Angeles',
    'Blacksburg',
    'New York',
];


export const usStateList = [
    'California',
    'Virginia',
    'South Carolina',
    'New York',
    'Texas',
];
